import { Link } from "react-router-dom";
import { TableContainer } from "./styles";
import { ReactSVG } from "react-svg";
import ativo from "../../../assets/ativo.svg";
import inativo from "../../../assets/inativo.svg";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import { toast } from "react-toastify";

const Table = ({ perfilSelecionado, textoPesquisa }) => {
  const [itens, setItens] = useState([]);

  //BUSCAR TODOS OS ITENS
  function buscarItens() {
    api
      .get("/itens")
      .then((response) => {
        setItens(response.data.data.itens);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da API:", error);
        toast.error("Erro ao buscar dados");
      });
  }
  useEffect(() => {
    buscarItens();
  }, []);

  const colunas = ["Id", "Nome", "Perfil", "Data de cadastro", "Status"];
  const filtrarCategoria = (categoria) => {
    const perfilFiltrado =
      !perfilSelecionado || categoria.status === parseInt(perfilSelecionado);
    const pesquisaFiltrada =
      !textoPesquisa ||
      categoria.nome.toLowerCase().includes(textoPesquisa.toLowerCase());

    const idCategoria = parseInt(textoPesquisa);
    const idFiltrado = !isNaN(idCategoria) && categoria.id === idCategoria;

    return perfilFiltrado && (pesquisaFiltrada || idFiltrado);
  };

  const usuariosFiltrados = itens.filter(filtrarCategoria);

  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {colunas.map((coluna) => (
              <th key={coluna}>{coluna}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {usuariosFiltrados.map((lista) => (
            <tr className="map" key={lista.id}>
              <td>#{lista.id}</td>
              <td>{lista.nome}</td>
              <td>{lista.categoria_item}</td>
              <td>{lista.data_criacao}</td>
              {lista.status === 1 ? (
                <td>
                  <div className="ativo">
                    <ReactSVG src={ativo} />
                    <p>ativo</p>
                  </div>
                </td>
              ) : (
                <td>
                  <div className="ativo">
                    <ReactSVG src={inativo} />
                    <p>inativo</p>
                  </div>
                </td>
              )}

              <td className="td-editar">
                <Link
                  to={`/item/editar/${lista.id}`}
                  className="editar"
                  htmlFor="editar"
                >
                  Abrir
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default Table;
